export const CATEGORY_WITH_SUBCATEGORY_AND_TYPE = ['V', 'F', 'P'];

export const creationMode = {
	NewCase: 'new-case',
	OldCase: 'old-case'
};

export const CLERK_TYPE_CA_DA = ['CA', 'DA'];


export const HOT_CHECK_SUB_CATEGORY = 'HC';
